import React, { useContext, useEffect, useState } from "react";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import { NextSeo } from "next-seo";
import { Nav } from "@/components/navigation/Navbar";
import Crumbs from "@/components/navigation/Crumbs";
import * as Text from "@/components/text";
import Announcement from "@/components/initiatives/Announcement";
import DownloadableMaterials from "@/components/initiatives/DownloadableMaterials";
import Testimonials from "pages/iniciativas/Testimonials";
import PreviousEditions from "@/components/initiatives/PreviousEditions";
import Partners from "@/components/initiatives/Partners";
import { GlobalContext } from "@/stores/GlobalContextProvider";
import HeroMedia from "@/components/lib/HeroMedia";
import { localeTexts } from "@/utils/locale";

export default function AmbulantePresenta({ mediaCenter, locale }) {
  const [mediaCenterData, setMediaCenterData] = React.useState({
    ...mediaCenter,
  });
  const globalConfiguration = useContext(GlobalContext);

  useEffect(() => {
    if (locale === "en" && mediaCenter.localizations?.data?.length > 0) {
      const englishData = mediaCenter.localizations.data.find(
        (localization) => localization.attributes.locale === "en"
      );

      if (englishData?.attributes) {
        const englishAttributes = englishData.attributes;
        setMediaCenterData({
          ...mediaCenter,
          ...englishAttributes,
          stats: englishAttributes.stats || mediaCenter.stats,
          quotes: englishAttributes.quotes || mediaCenter.quotes,
          aliados: englishAttributes.aliados || mediaCenter.aliados,
          qa: englishAttributes.qa || mediaCenter.qa,
          downloads: englishAttributes.downloads || mediaCenter.downloads,
          past_downloads:
            englishAttributes.past_downloads || mediaCenter.past_downloads,
          active_call: englishAttributes.active_call || mediaCenter.active_call,
          inactive_call:
            englishAttributes.inactive_call || mediaCenter.inactive_call,
          hero_media: mediaCenter.hero_media,
        });
      } else {
        setMediaCenterData({ ...mediaCenter });
      }
    } else {
      setMediaCenterData({ ...mediaCenter });
    }
  }, [locale, mediaCenter]);

  return (
    <>
      <div className="amb-container">
        <Nav className="grow bg-gray-100" theme="light" />
        <NextSeo
          title={localeTexts[locale].AmbulantePresenta.titleSeo}
          description="Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante"
          canonical={`https://ambulante.org/ambulante-presenta}`}
          openGraph={{
            url: `https://ambulante.org/ambulante-presenta`,
            title: "Ambulante Presenta - Ambulante",
            description:
              "Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante",
            site_name: "Ambulante",
          }}
        />
        <div className="flex flex-row gap-2 py-4">
          <Crumbs
            breadcrumbs={[
              { href: "/", text: localeTexts[locale].breadcrumbs.home || localeTexts[locale].breadcrumbs.Home },
              {
                href: "/iniciativas/gira?seccion=las-peliculas",
                text: localeTexts[locale].breadcrumbs.programs,
              },
            ]}
          />
          <Text.NavigationLabel className="mt-0.5 text-xs font-thin text-neutral-600 md:mt-1.5">
            {localeTexts[locale].AmbulantePresenta.title}
          </Text.NavigationLabel>
        </div>
      </div>

      <div className="mb-8 mt-7 flex flex-col items-center justify-center text-center md:mt-10 md:px-28 lg:mt-14 lg:px-32">
        <div className="w-full text-center font-bold text-presenta">
          <Text.Title className="text-[22px] md:text-2xl md:font-semibold lg:text-2xl">
            {localeTexts[locale].AmbulantePresenta.title}
          </Text.Title>
        </div>
        <div className="w-full px-4 py-2 text-center text-4xl font-bold leading-9 md:mb-4 md:mt-4 md:px-32 md:text-[30px] lg:px-52 lg:text-4xl">
          <h2>{mediaCenterData?.title}</h2>
        </div>
        <div className="w-full px-4 text-center md:px-20 lg:px-40">
          <Text.Headline className="text-xl font-normal leading-7 lg:text-[30px]">
            {mediaCenterData?.subtitle}
          </Text.Headline>
        </div>
        {mediaCenterData?.description ? (
          <div
            className={`w-full max-w-[950px]  rounded-md bg-[#fff4d4] p-4 text-center text-sm font-light leading-7 lg:mt-4 lg:text-[18px] lg:leading-[22px]`}
          >
            {mediaCenterData?.description}
          </div>
        ) : null}
      </div>
      {mediaCenterData?.hero_media && (
        <div className="flex w-full items-center justify-center">
          <div className="w-full pb-8 lg:max-w-[1440px] lg:pt-12">
            <HeroMedia media={mediaCenterData?.hero_media} />
          </div>
        </div>
      )}
      {mediaCenterData?.show_call && (
        <div className="flex w-full justify-center">
          <Announcement
            data={mediaCenterData?.active_call}
            qa={mediaCenterData?.qa}
            isActive={globalConfiguration?.ambulante_presenta}
            inactiveData={mediaCenterData?.inactive_call}
            type="presenta"
          />
        </div>
      )}
      <div className="space-y-3">
        <DownloadableMaterials
          data={mediaCenterData?.downloads}
          label={localeTexts[locale].AmbulantePresenta.materialesDescargables}
          locale={locale}
        />
        {mediaCenterData?.past_downloads?.length > 0 ? (
          <DownloadableMaterials
            data={mediaCenterData?.past_downloads}
            label={localeTexts[locale].AmbulantePresenta.materialesDescargablesAnt}
            locale={locale}
          />
        ) : null}
      </div>
      <div className="mb-8 flex w-full items-center justify-center bg-black">
        <div className="max-w-[1440px] bg-black px-4 py-10 text-white sm:w-full md:flex md:justify-between md:gap-16 md:px-12 lg:w-full lg:px-40">
          {mediaCenterData?.stats?.map((stat, i) => (
            <div className="mb-12 text-center md:mb-0" key={i}>
              <Text.Display
                as="p"
                className="mb-2 text-5xl font-bold md:text-[40px]"
              >
                {stat?.stat}
              </Text.Display>
              <Text.Headline
                as="p"
                className="mb-2 text-[32px] font-bold md:text-[28px]"
              >
                {stat?.title}
              </Text.Headline>
              <Text.Noun as="p" className="text-xl md:text-base ">
                {stat?.description}
              </Text.Noun>
            </div>
          ))}
        </div>
      </div>

      <PreviousEditions locale={locale} />
      <div className="flex items-center justify-center px-2 md:px-0">
        <Testimonials
          title={localeTexts[locale].AmbulantePresenta.testimonialsTitle}
          subtitle={localeTexts[locale].AmbulantePresenta.testimonialsSubtitle }
          quotes={mediaCenterData?.quotes}
          locale={locale}
        />
      </div>
      <div className="mb-20">
        <Partners arrayPartners={mediaCenterData?.aliados[0]?.aliado} locale={locale} />
      </div>
    </>
  );
}

export async function getServerSideProps(context) {
  const { locale } = context.query;
  try {
    const q = qs.stringify({
      populate: {
        localizations: {
          populate: "*",
        },
        qa: "*",
        stats: "*",
        quotes: "*",
        active_call: "*",
        inactive_call: "*",
        downloads: "*",
        past_downloads: "*",
        show_call: "*",
        hero_media: "*",
        aliados: {
          populate: {
            aliado: {
              populate: {
                logo: "*",
              },
            },
          },
        },
      },
    });
    const { data } = await apiClient.get(`/api/ambulante-presenta?${q}`);
    return {
      props: {
        mediaCenter: data.data.attributes,
        locale: locale || "es-MX",
      },
    };
  } catch (err) {
    console.log(err);
    return {
      notFound: true,
    };
  }
}
